module.exports = __webpack_public_path__ + "static/media/knear.128277ca.png";